import { useTranslation } from 'react-i18next';

/**
 * Admin preview of the checkout out-of-home upgrade card (Figma 712-17518),
 * mirroring the live `ui-checkout-banner` extension: the baked locker artwork on
 * the left, then the headline, benefit bullets and a "Learn more" link. The image
 * is the same static asset the checkout extension serves
 * (frontend/public/assets/extension/ooh-banner-card.png).
 */
export function OohPopupPreview() {
  const { t } = useTranslation('widgets');

  const benefits = [
    t('oohPopup.card.benefit1'),
    t('oohPopup.card.benefit2'),
    t('oohPopup.card.benefit3'),
  ];

  return (
    <div className="rounded-[12px] bg-white p-5">
      <div
        className="flex items-start gap-[15px]"
        style={{ fontFamily: "'Google Sans', system-ui, -apple-system, sans-serif" }}
      >
        <div className="flex h-[145px] w-[92px] shrink-0 items-center justify-center rounded-[4px]">
          <img
            src="/assets/extension/ooh-banner-card.png"
            alt=""
            aria-hidden
            className="h-full w-full object-contain"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-2.5 pt-2">
          <p className="text-[15px] font-medium leading-[1.5] text-black">
            {t('oohPopup.card.title')}
          </p>
          <ul className="list-disc ps-[21px] text-[14px] leading-[1.59] text-[#424242]">
            {benefits.map((benefit) => (
              <li key={benefit}>{benefit}</li>
            ))}
          </ul>
          <span className="text-[12px] text-black underline">{t('oohPopup.card.learnMore')}</span>
        </div>
      </div>
    </div>
  );
}
